module.exports = __webpack_public_path__ + "static/media/document.d0bd3b15.svg";